import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualGradeAttendance from "./routes/IndividualGradeAttendance";

export default store => {
  return {
    path: "grade",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "grade" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualGradeAttendance(store)],
  };
};
